<template>
  <div class="row bg-light pt-4" id="vp">
    <div class="col-12">
      <div class="p-4 card" v-if="!selectedClient || !selectedClient.id">
        <h4>Who's the Outbound for?</h4>
        <vue-select
          :options="clients"
          label="name"
          v-model="selectedClient" 
          placeholder="Select a client..."></vue-select>      
      </div>
      <div class="row" v-if="selectedClient && selectedClient.id">
        <div class="col-12">
          <h2>
            New Outbound for {{ selectedClient.name }}
          </h2>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label>DESTINATION</label>
              <vue-select
                @input="handleDestinationChange"
                :options="addresses"
                label="name"
                v-model="selectedAddress" 
                placeholder="New Address"></vue-select>  
          </div>          
          <div class="form-group">
            <label>NAME</label>
            <input type="text" class="form-control form-control-sm" v-model="order.ship_name" />
          </div>
          <div class="form-group">
            <label>ADDRESS</label>
            <input type="text" class="form-control form-control-sm" v-model="order.ship_address" />
          </div>
          <div class="form-row">
            <div class="form-group col-6">
              <label>CITY</label>
              <input type="text" class="form-control form-control-sm" v-model="order.ship_city" />
            </div>
            <div class="form-group col-3">
              <label>STATE</label>
              <input type="text" class="form-control form-control-sm" v-model="order.ship_state" />
            </div>
            <div class="form-group col-3">
              <label>ZIP</label>
              <input type="text" class="form-control form-control-sm" v-model="order.ship_zip" />
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label>PO NUMBER</label>
            <input type="text" class="form-control form-control-sm" v-model="order.po_number" />
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label>CARRIER</label>
              <vue-select
                :options="carriers"
                label="name"
                v-model="selectedCarrier" 
                placeholder="Select carrier..."></vue-select>  
          </div>
          <div class="form-group">
            <label>TRACKING NUMBER</label>
            <input type="text" class="form-control form-control-sm" v-model="order.tracking_number" />
          </div>          
        </div>
      </div>
      <div class="card mt-4" v-if="selectedClient && selectedClient.id">
        <div class="card-header">
          <h5 class="card-title m-0">Line Items</h5>
        </div>
        <table class="table w-100 bg-white table-striped">
          <thead>
            <tr>
              <th>SKU / DESCRIPTION</th>
              <th style="width: 100px;">QTY</th>
              <th style="width: 100px;">UNITS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in items" :key="index">
              <td>
                <vue-select :options="products" v-model="item.product"></vue-select>
              </td>
              <td>
                <input class="form-control" type="number" v-model="item.qty" style="width: 100px;">
              </td>
              <td>
                <select v-model="item.package_id" class="form-control">
                  <option value="0">EA</option>
                  <option value="1">CS</option>
                  <option value="2">PLT</option>
                </select>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td><button class="btn btn-sm" @click="addLine">Add Line</button></td>
              <td>{{ totalQty }} <strong>TOTAL</strong> </td>
              <td></td>
            </tr>
          </tfoot>
        </table>
        <div class="p-2">
          <button class="btn btn-block btn-primary" @click="submit">Submit</button>
        </div>        
      </div>
    </div>
  </div>
</template>

<script>

import VueSelect from 'vue-select'
import api from '@/api'


const defaultItem = {
  package_id: 1,
  qty: 1
}

export default {
  name: 'order-new',

  components: {
    VueSelect
  },
  
  data() {
    return {
      selectedClient: null,
      selectedCarrier: null,
      selectedAddress: {},
      clients: [],
      carriers: [],
      rawProducts: [],
      addresses: [],
      items: [Object.assign({}, defaultItem)],
      order: {}
    }
  },

  watch: {
    selectedClient() {
      if (!this.selectedClient) {
        return
      }
      api.get(`/clients/${this.selectedClient.id}/products`).then(res => {
        this.rawProducts = res.data.products
      })

      api.get(`/clients/${this.selectedClient.id}/addresses`).then(res => {
        this.addresses = res.data.addresses
      })
    }
  },

  created() {
    api.get('/clients').then((res) => {
      this.clients = res.data.clients
    })

    api.get('/carriers').then((res) => {
      this.carriers = res.data.carriers
    })
  },

  computed: {
    products() {
      return this.rawProducts.map(p => ({ 
        id: p.id,
        sku: p.customer_sku,
        label: `${p.customer_sku} - ${p.name}`
      }))
    },

    totalQty() {
      return this.items.reduce((sum, item) => sum + parseInt(item.qty || 0), 0)
    }
  },

  methods: {
    handleDestinationChange(address) {
      this.order.ship_name = address.name
      this.order.ship_address = address.address
      this.order.ship_city = address.city
      this.order.ship_state = address.state
      this.order.ship_zip = address.zip
    },

    addLine() {
      this.items.push(Object.assign({}, defaultItem))
    },

    submit() {
      this.loading = true
      const order = this.order
      order.items = this.items
      order.client_id = this.selectedClient.id
      order.carrier_id = this.selectedCarrier.id
      order.destination_id = this.selectedAddress.id
      
      api.post('/outbound-orders', { order }).then(() => {
        this.loading = false
        this.$router.push('/outbound')
      })
    }
  }
}
</script>


<style scoped>
label {
  font-size: 0.75rem;
  color: #666666;
  margin: 0px;
}

.form-control {
  padding-left: 0.5rem;
}

.form-group {
  margin: 5px 0;
}

#vp {
  height: calc(100vh - 48px);
  overflow-y: auto;
}
</style>